'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalCheckoutStepOneComponent = exports.rentalCheckoutStepOneComponent = {
    template: require('./rental-checkout-step-one.html'),
    bindings: {
        rentalProduct: '<',
        deliveryInfo: '<',
        contactInfo: '<',
        onDeliveryInfoChange: '&',
        onContactInfoChange: '&',
        onProductsRentedSucces: '&',
        onFormValidChange: '&'
    },
    controllerAs: 'vm',
    controller: ["rentalProductsService", function controller(rentalProductsService) {
        'ngInject';

        var vm = this;
        vm.deliveryInfoChange = deliveryInfoChange;
        vm.contactInfoChange = contactInfoChange;
        vm.confirmOrder = confirmOrder;
        vm.onFormChange = onFormChange;
        vm.isFormValid = false;

        function deliveryInfoChange($event) {
            vm.onDeliveryInfoChange({
                $event: $event
            });
        }

        function contactInfoChange($event) {
            vm.onContactInfoChange({
                $event: $event
            });
        }

        function confirmOrder() {
            if (vm.checkoutForm.$valid && vm.isFormValid) {
                rentalProductsService.orderRentedProducts(vm.rentalProduct, null, null, vm.contactInfo, vm.deliveryInfo).then(function (result) {
                    vm.onProductsRentedSucces({
                        $event: result
                    });
                });
            }
        }

        function onFormChange() {
            vm.isFormValid = checkFormValid();
        }

        function checkFormValid() {
            return vm.checkoutForm.dpicker.$valid && vm.checkoutForm.$valid && vm.deliveryInfo.postalLocalityId !== 0 && vm.deliveryInfo.streetId !== 0;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/rental/rental-checkout-step-one.js
// module id = 1000
// module chunks = 0